module.exports = {
  body: '#060c12',
  background: '#191d2b',
  backgroundDark: '#10121b',

  text: '#fafafa',
  navtext: '#e0e0e0',

  primary: '#e0e0e0',
  primaryLight: '#191d2b',
  primaryDark: '#191d2b',

  secondary: '#10121b',
  secondaryLight: '#191d2b',
  secondaryDark: '#10121b',
};
